import React from "react";
import { Button, Typography, Divider } from "antd";
import { useTranslation } from "react-i18next";
import { PlusOutlined, TeamOutlined } from "@ant-design/icons";
// Importamos la nueva Card
import { TherapyItemCard } from "../TherapyItemCard";
import "./TherapySidebar.scss";

const { Text } = Typography;

// Añadimos props para editar y borrar
export function TherapySidebar({
  therapies,
  onCreate,
  onShared,
  onView,
  onEdit,
  onDelete,
  onCargarMas,
  cargandoMas = false,
  quedan = false,
  total,
}) {
  const { t } = useTranslation(["ui", "common"]);

  return (
    <div className="revi-therapy-sidebar">
      {/* SECCIÓN SUPERIOR: Acciones */}
      <div className="sidebar-actions">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            width: "100%",
          }}
        >
          <Button
            type="primary"
            icon={<PlusOutlined />}
            block
            size="large"
            onClick={onCreate}
            className="action-btn-primary"
          >
            {t("terapias.panel.crear")}
          </Button>

          <Button
            icon={<TeamOutlined />}
            block
            size="large"
            onClick={onShared}
            className="action-btn-secondary"
          >
            {t("terapias.panel.compartidas")}
          </Button>
        </div>

        <div className="sidebar-info-text">
          <Text type="secondary">{t("terapias.panel.ayuda")}</Text>
        </div>
      </div>

      <Divider style={{ margin: 0 }} />

      {/* SECCIÓN INFERIOR: Lista de Cards */}
      <div className="sidebar-content">
        {/*
          El contador va dentro de la plantilla. Antes era una frase montada
          a trozos en el JSX.
        */}
        <div className="list-header">
          <Text strong>
            {t("terapias.misTerapias", {
              count: total ?? therapies.length,
            })}
          </Text>
        </div>

        {therapies.length > 0 ? (
          <div className="therapy-list-wrapper">
            {therapies.map((item) => (
              <TherapyItemCard
                key={item._id}
                therapy={item}
                onView={onView}
                onEdit={onEdit}
                onDelete={onDelete}
              />
            ))}

            {/* Sin esto, la terapia numero once no era alcanzable desde
                ninguna parte del portal. */}
            {quedan && onCargarMas ? (
              <Button
                block
                onClick={onCargarMas}
                loading={cargandoMas}
                className="therapy-list-more"
              >
                {t("common:actions.loadMore")}
              </Button>
            ) : null}
          </div>
        ) : (
          <div className="empty-state">
            <Text type="secondary">{t("terapias.panel.vacio")}</Text>
          </div>
        )}
      </div>
    </div>
  );
}
